import createVueApp from '@/common/create_app'
import { useLocationStore } from '@/stores/location'
import { useMediaStore } from '@/stores/media'

async function initDashboardPage(componentImport, props, layoutProps) {
  const [{ default: Component }, { default: DashboardLayout }] = await Promise.all([
    componentImport,
    import('@/vue_widgets/locations/dashboard/layout')
  ])
  createVueApp(Component, {
    props,
    layout: DashboardLayout,
    layoutProps,
    state: (pinia) => {
      useLocationStore(pinia).setLocationData(props)
    }
  })
}

Styxie.Initializers.OrganizationsLocations = {
  index: async(props) => {
    const { default: Locations } = await import('@/vue_widgets/locations/location_list/index.vue')
    createVueApp(Locations, { props })
  },
  media_v2: async(props) => {
    const [
      { default: MediaLibrary },
      { default: DashboardLayout }
    ] = await Promise.all([
      import('@/vue_widgets/locations/media/index.vue'),
      import('@/vue_widgets/locations/dashboard/layout')
    ])
    createVueApp(MediaLibrary, {
      layout: DashboardLayout,
      layoutProps: { title: 'Overview' },
      state: (pinia) => {
        const locationStore = useLocationStore(pinia)
        locationStore.setLocationData(props)
        const mediaStore = useMediaStore(pinia)
        mediaStore.setMediaConfig(props.mediaData || {})
      }
    })
  },
  notifications_v2: async(props) => {
    const { notificationSettings, ...locationData } = props

    const [
      { default: NotificationSettings },
      { default: DashboardLayout }
    ] = await Promise.all([
      import('@/vue_widgets/locations/notification-settings/index.vue'),
      import('@/vue_widgets/locations/dashboard/layout')
    ])

    createVueApp(NotificationSettings, {
      props: { notificationSettings },
      layout: DashboardLayout,
      layoutProps: { title: 'Notifications' },
      state: (pinia) => {
        const locationStore = useLocationStore(pinia)
        locationStore.setLocationData(locationData)
      }
    })
  }
}

Styxie.Initializers.OrganizationsLocationsDashboard = {
  show: (props) => initDashboardPage(import('@/vue_widgets/locations/dashboard/index.vue'), props),
  automation: (props) => initDashboardPage(import('@/vue_widgets/locations/automation'), props),
  change_log: (props) => initDashboardPage(import('@/vue_widgets/locations/change-log'), props),
  edit: (props) => initDashboardPage(import('@/vue_widgets/locations/edit'), props),
  local_posts: (props) => initDashboardPage(import('@/vue_widgets/locations/local_posts'), props),
  local_post_new: (props) => initDashboardPage(import('@/vue_widgets/locations/local_posts/form'), props),
  local_post_edit: (props) => initDashboardPage(import('@/vue_widgets/locations/local_posts/form'), props),
  keywords: (props) => initDashboardPage(import('@/vue_widgets/locations/keywords'), props),
  keyword_new: (props) => initDashboardPage(import('@/vue_widgets/locations/keywords/new'), props, { title: 'Add Keywords' }),
  keyword_show: (props) => initDashboardPage(import('@/vue_widgets/locations/keywords/show'), props),
  reviews: (props) => initDashboardPage(import('@/vue_widgets/locations/reviews'), props)
}
